<div class="main-page-section default_font p-3 p-md-4 px-lg-5">
    <div class="breadcrumbs-section p-0 mb-3 mb-md-4 mb-lg-5">
        <span class="prev-page pr-1 prev"><a routerLink="/overview">Home</a></span>
        <span class="separator">&nbsp; &nbsp;</span>
        <img src="../../assets/images/seperator.png">
        <span class="separator">&nbsp; &nbsp;</span>
        <span class="prev-page pr-1 prev"><a routerLink="/list-service-group">View List of Customer Service
                Groups</a></span>
        <span class="separator">&nbsp; &nbsp;</span>
        <img src="../../assets/images/seperator.png">
        <span class="separator">&nbsp; &nbsp;</span>
        <span class="curr-page pl-1 breadcrumbs-section-font">Customer Service Group Details</span>
        <!-- <span class="separator">&nbsp; > &nbsp;</span>
        <span class="curr-page pl-1 breadcrumbs-section-font">Plant Details</span> -->
    </div>
    <div class="d-flex align-items-center justify-content-between mb-3 mb-md-4">
        <h2 class="font-weight-medium mb-3 mb-md-4">{{mainGroupName}}</h2>
    </div>

    <!-- <div class="mt-4">
        <div class="col-12 row borders m-0 p-0 ">
            <div class="pt-3 pb-3 d-flex" [autoClose]="'outside'" [ngbPopover]="popContent" triggers="manual"
                #p="ngbPopover" (click)="openPopover(p)" (clickOutside)="onClickedOutside($event)" placement="bottom"
                popoverClass='dash-popover dashboard-popover'
                class="col-4 borders-right pt-3  pr-0 padding-left-meeting organization"> Groups
                <span class="d-flex justify-content-end"><img src="/assets/images/Path.png"
                        class="padding-left-image pr-3 justify-content-between" /></span>

                <div class="all">{{selectedGroupName}}</div>

                <div>
                    <ng-template #popContent>
                        <div class="popupHeader">
                            <img src="../../assets/images/search.png">
                            <input type="text" placeholder='Search' [(ngModel)]="searchGroup" />
                        </div>
                        <div class="template p-0 ">

                            <div class="dashboard-popover ">
                                <div class="d-flex justify-content-between ">
                                    <div class="pl-3 pr-3 pb-3 ">
                                        
                                        <div class="row pb-2"
                                            *ngFor="let group of mainGroups | filter: searchGroup;let i=index">
                                            <div class="popover-content pl-3 email-width col-11"
                                                (click)="selectGroupid(group)">
                                                {{group?.groupName}}
                                            </div>
                                            <div class="col-1">
                                                <img src="/assets/images/tick.png"
                                                    *ngIf="multiSelectGroup == group?.groupName || (group.groupName == null && multiSelectGroup.length == 0)"
                                                    class="" loading="lazy" />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </div>
            </div>
            <div class="search-wrapper mt-3">
                <label for="search">
                    <img class="image-pos pl-4" src="/assets/images/search.png" alt="search">
                    <input class="search-box search-padding  pt-1" type="text" name="searchText" id="menu-search"
                        [(ngModel)]="searchText" placeholder="Search by Name…" (keyup)="searchByText(searchText)"
                        (search)="searchByText(searchText)">
                </label>
            </div>
        </div>
    </div> -->

    <div
        class="search_bar border-top border-bottom border-light mx-n3 mx-md-n4 mx-lg-n5 px-3 px-md-4 px-lg-5 mb-4 mb-md-5">
        <form class="search_form">
            <svg-icon src="../../../assets/images/icons/search.svg"></svg-icon>
            <input type="text" name="searchText" id="searchText" class="search_field"
                placeholder="Search by Customer Service User Name" [(ngModel)]="searchText"
                (keyup)="searchByText(searchText)" (search)="searchByText(searchText)" #searchcontact="ngModel">
            <button type="submit" class="d-none"></button>
        </form>
    </div>

    <div class="mb-4 mb-md-5 d-flex align-items-center justify-content-between">
        <h3 class="h6 font-weight-bold text-dark">{{totalRows}}
            Customer Service User{{totalRows > 1 ? 's' : null}}</h3>
        <div class="d-flex align align-items-center column-gap-2">
            <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" [(ngModel)]="masterSelectedUsers" name="list_name"
                    value="m1" (change)="checkUncheckAll()" id="all_list_name">
                <label class="custom-control-label cursor-pointer" for="all_list_name">Select all</label>
            </div>
            <div ngbDropdown *ngIf="showDropdown">
                <button type="button" class="dropdown_dots px-2 text-primary" id="download_dropdown" ngbDropdownToggle>
                    <svg-icon src="../../../assets/images/icons/more_dots.svg"
                        [svgStyle]="{ 'height.px':20 }"></svg-icon>
                </button>
                <div ngbDropdownMenu aria-labelledby="download_dropdown">
                    <button ngbDropdownItem (click)="openModalMoveGroup(checkedOnlyUsersList)">Move to new
                        group</button>
                </div>
            </div>
        </div>
    </div>

    <div class="row row-gap-4">
        <div class="col-12 col-md-6 col-lg-4 col-xl-3" *ngFor="let serviceuser of newmainServiceUserList | filter:searchText | paginate: { itemsPerPage: 10,
            currentPage: page, totalItems:newmainServiceUserList?.length }; let i=index ">
            <div class="bg-lighter p-3 rounded h-100 d-flex flex-column">
                <div class="d-flex align-items-start column-gap-2 mb-2">

                    <div class="custom-control custom-checkbox flex-shrink-0 pt-2">
                        <input type="checkbox" class="custom-control-input" [(ngModel)]="serviceuser.isSelected"
                            name="list_name" [id]="serviceuser.userId + 'list_name'" value="{{serviceuser.userId}}"
                            (change)="isAllSelected()">
                        <label [for]="serviceuser.userId + 'list_name'"
                            class="custom-control-label cursor-pointer"></label>
                    </div>
                    <div class="list_image">
                        <img src="./assets/images/add-admin.png" alt="">
                    </div>
                    <div class="pl-2">
                        <h3 class="font-weight-bold text-primary h5 mb-1 mb-md-2 cursor-pointer"
                            (click)="goToServiceGroupDetails(serviceuser.userId)">
                            {{serviceuser.userFullName}}</h3>
                        <span class="font-weight-normal d-block small mb-1">username: {{serviceuser.userName}}</span>
                    </div>
                </div>
                <span
                    (click)="openModal(serviceuser.userFullName, serviceuser.userName, serviceuser.userId, groupId, fromDetailsPage)"
                    class="font-weight-bold small mb-0 mt-auto cursor-pointer remove-button-color">Remove from
                    group</span>
            </div>
        </div>
    </div>

    <div class="d-flex justify-content-center pagination-section mt-4" *ngIf="mainServiceUserList?.length > 10">
        <div class="custom_pagination mt-4 mt-md-5 small">
            <div class="border border-light">
                <pagination-controls class="pagination" (pageChange)="handelServiceUserList($event)"
                    class="d-flex justify-content-center">
                </pagination-controls>
                <div class="page_numbers">
                    {{indexPage}}/{{paginationCount(mainServiceUserList?.length)}}</div>
                <!-- <div class="page_numbers">
                    {{paginationCount(mainServiceUserList?.length)}}/{{indexPage}}</div> -->
            </div>
        </div>
    </div>
</div>